<!-- background-color:#032d57;box-shadow: 0px 0 10px rgba(0, 0, 0, 0.6);background-color:#032d57; -->
<div class="mapcontainer" style="box-shadow: 0px 0 10px rgba(0, 0, 0, 0.6);padding-top: 135px;">
    <div class="map">
        <!-- <span>Alternative content for the map</span> -->
    </div>
    <br />
    <div class="row">
        <div class="col-lg-3"></div>
        <div class="col-lg-2 bluecoverage">
            <label>Local Coverage</label>
        </div>
        <div class="col-lg-2 redcoverage">
            <label>Extended Coverage</label>
        </div>
        <div class="col-lg-2 graycoverage">
            <label (click)="bottomscroll()" style="cursor: pointer;"><span style="color: #032d57;"><b>Contact
                        us</b></span> for rates and availability</label>
        </div>
        <div class="col-lg-3"></div>
    </div>
</div>

<!-- ======= Services Section ======= -->
<section id="services" class="services layout_padding_top section-bg">
    <div class="container-fluid" data-aos="fade-up">
        <div class="row">
            <div class="col-md-3" style="height: 300px;" data-aos="fade-up" data-aos-delay="100">
                <a href="/colorado">
                    <div class="icon-box" style="height: 275px;">
                        <h4>Colorado/Corporate Office</h4>
                        <p><i class="fa fa-map-marker"></i>&nbsp;8595 S Prairie Trail Drive, Suite 200, Englewood, CO
                            80112</p>
                        <p><i class="fa fa-phone-square"></i>&nbsp;303-649-1304</p>
                        <p><i class="fa fa-envelope-o"></i>&nbsp;<a href="mailto:customerservice@sfisafety.com">
                                customerservice@sfisafety.com</a></p>
                    </div>
                </a>
            </div>
            <!-- <div class="col-md-4" style="height: 300px;" data-aos="fade-up" data-aos-delay="200">
                <a href="/texas">
                    <div class="icon-box" style="height: 275px;">
                        <h4>Texas Office</h4>
                        <p><i class="fa fa-map-marker"></i>&nbsp;&nbsp;13155 Noel Road, Suite 900, Dallas, TX 75240</p>
                        <p><i class="fa fa-phone-square"></i>&nbsp;&nbsp;214-646-1496</p>
                        <p><i class="fa fa-envelope-o"></i>&nbsp;<a href="mailto:customerservice@sfisafety.com">
                                customerservice@sfisafety.com</a></p>

                    </div>
                </a>
            </div> -->
            <div class="col-md-3" data-aos="fade-up" data-aos-delay="300">
                <a href="/arizona">
                    <div class="icon-box" style="height: 275px;">
                        <h4>Arizona Office</h4>
                        <p><i class="fa fa-map-marker"></i>&nbsp;&nbsp;6424 E Greenway Pkwy., Suite #100m Scottsdale, AZ
                            85254</p>
                        <p><i class="fa fa-phone-square"></i>&nbsp;&nbsp;602-325-1950</p>
                        <p><i class="fa fa-envelope-o"></i>&nbsp;<a href="mailto:customerservice@sfisafety.com">
                                customerservice@sfisafety.com</a></p>
                        <p>&nbsp;</p>
                    </div>
                </a>
            </div>

          

            <div class="col-md-3" data-aos="fade-up" data-aos-delay="400">
                <a href="/florida">
                    <div class="icon-box" style="height: 275px;">
                        <h4>Florida Office</h4>
                        <p><i class="fa fa-map-marker"></i>&nbsp;&nbsp;1170 Gulf Blvd, Suite 1403, Clearwater, FL 33767
                        </p>
                        <p><i class="fa fa-phone-square"></i>&nbsp;&nbsp;813-867-7200</p>
                        <p><i class="fa fa-envelope-o"></i>&nbsp;<a href="mailto:customerservice@sfisafety.com">
                                customerservice@sfisafety.com</a></p>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                    </div>
                </a>
            </div>

            <div class="col-md-3" data-aos="fade-up" data-aos-delay="500">
                <a href="/nc">
                    <div class="icon-box" style="height: 275px;">
                        <h4>North Carolina Office</h4>
                        <p><i class="fa fa-map-marker"></i>&nbsp;&nbsp;2015 Ayrsley Town Blvd #202, Charlotte NC 28273
                        </p>
                        <p><i class="fa fa-phone-square"></i>&nbsp;&nbsp;980-217-6100</p>
                        <p><i class="fa fa-envelope-o"></i>&nbsp;<a href="mailto:customerservice@sfisafety.com">
                                customerservice@sfisafety.com</a></p>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                    </div>
                </a>
            </div>
           
        </div>
    </div>
</section><!-- End Services Section -->


<!-- ======= Contact Section ======= -->
<section id="contact" class="contact section-bg">
    <div id="contactcontiner" class="container" data-aos="fade-up">

        <div class="section-title">
            <h3>Please contact us with your questions or comments and we will be in touch with you promptly.</h3>
        </div>

        <div class="row mt-1 d-flex justify-content-end" data-aos="fade-right" data-aos-delay="100">

            <div class="col-lg-12 mt-lg-0" data-aos="fade-left" data-aos-delay="100">
                <div class="row">
                    <div class="col-md-6 mt-2">
                        <input type="text" name="name" [(ngModel)]="name" class="form-control redborder" id="name"
                            placeholder="Your Name" minlength="4" />
                    </div>
                    <div class="col-md-6 mt-2">
                        <input type="text" name="company" [(ngModel)]="company" class="form-control redborder"
                            id="company" placeholder="Your Company/Organization" minlength="4" />
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6 mt-2">
                        <input type="text" name="email" [(ngModel)]="email" class="form-control redborder" id="email"
                            placeholder="Your Email Address" minlength="4" />
                    </div>
                    <div class="col-md-6 mt-2">
                        <input type="text" name="phone" [(ngModel)]="phone" class="form-control redborder" id="phone"
                            placeholder="Phone Number" minlength="4" />
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col-md-12">
                        <p style="border-bottom: solid 1px gray;padding-bottom: 10px;">So we can quickly assist you,
                            please complete the following:</p>
                    </div>
                </div>

                <div class="row mt-2">
                    <div class="col-md-12 mt-2">
                        What types of services are you interested in?<span style="color: red;">*</span>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6 mt-2">
                        <ul style="list-style: none;display: block;">
                            <li><input type="checkbox" [(ngModel)]="general"> General Inquiry</li>
                            <li><input type="checkbox" [(ngModel)]="sp" /> Safety Programs </li>
                            <li><input type="checkbox" [(ngModel)]="st" /> Safety Training </li>
                            <li><input type="checkbox" [(ngModel)]="si" /> Safety Inspections </li>
                            <li><input type="checkbox" [(ngModel)]="AI" /> Accident Investigations </li>
                            <li><input type="checkbox" [(ngModel)]="osha" /> OSHA Informal Conference Assistance </li>
                            <li><input type="checkbox" [(ngModel)]="isot" /> Other <input type="text"
                                    [(ngModel)]="other" name="other" class="form-control mt-2" id="other"
                                    placeholder="Others" /></li>
                        </ul>
                    </div>
                    <div class="col-md-6 mt-2">
                        <input type="text" class="form-control" [(ngModel)]="loc" name="loc" id="loc"
                            placeholder="How many locations do you have?" />

                        <input type="text" class="form-control mt-2 redborder" [(ngModel)]="primary" name="primary"
                            id="primary" placeholder="Where is your primary location (City, State)?" />

                        <input type="text" class="form-control mt-2" [(ngModel)]="manager" name="manager" id="manager"
                            placeholder="Name of full-time safety manager (if applicable)?" />

                        <input type="text" class="form-control mt-2 redborder" [(ngModel)]="business" name="business"
                            id="business" placeholder="Describe your business or industry:" />
                    </div>

                </div>

                <div class="row">
                    <div class="col-md-3">

                    </div>
                    <div class="col-md-6 mt-3">
                        <button type="button" (click)="sendmessage()"
                            class="btn btn-outline-primary btn-lg btn-block">Send Message</button>
                    </div>
                    <div class="col-md-3">

                    </div>
                </div>

            </div>

        </div>

    </div>
</section><!-- End Contact Section -->